const assayOptions = {
  regular_assay: 'regular_assay',
  HF_assay: 'HF_assay',
  AB_assay: 'AB_assay',
};

export { assayOptions };
